import { Node } from '@tiptap/core'
import VueNodeViewRenderer from '@/tiptap/utils/VueNodeViewRenderer'

import CommentComponent from './CommentComponent'

export const CommentNode = Node.create({
  name: 'commentNode',

  addNodeView () {
    return VueNodeViewRenderer(CommentComponent, { as: 'span' })
  },

  addAttributes () {
    return {
      content: {
        default: null
      },
      contentid: {
        default: null
      }
    }
  },

  inline: true,
  group: 'inline',
  selectable: false,
  marks: '',

  parseHTML () {
    return [
      {
        priority: 51,
        tag: 'span[content]',
        getAttrs: dom => ({
          content: dom.getAttribute('content'),
          contentid: dom.getAttribute('contentid')
        })
      }
    ]
  },

  renderHTML ({ node }) {
    return [
      'span', { content: node.attrs.content, contentid: node.attrs.contentid, class: 'comment-content' },
      ['span', { class: 'icon-chat comment-icon' }],
      ['span']
    ]
  },

  addKeyboardShortcuts () {
    const preventDeleteNode = (state) => {
      const $pos = state.selection.$anchor
      const node = $pos.nodeBefore

      if ((node && node.type.name === 'commentNode') || (node && node.type.name === 'file' && node.attrs.percent >= 0)) {
        return true
      }
    }
    return {
      Backspace: preventDeleteNode,
      'Mod-Backspace': preventDeleteNode,
      Delete: preventDeleteNode,
      'Mod-Delete': preventDeleteNode
    }
  },

  addCommands () {
    return {
      addCommentNode: (attrs) => ({ dispatch, state }) => {
        if (attrs.commentid) {
          if (!attrs.comment) {
            const el = document.querySelector(`span[contentid="${attrs.commentid}"]`)
            el.parentNode.remove()
          }
          return
        }

        const content = attrs.content

        if (!content) return

        const { selection } = state

        const node = this.type.create(attrs)
        const transaction = state.tr.insert(selection.$from.pos, node)
        dispatch(transaction)
      }
    }
  }
})
